import { useEffect, useState } from "react";
import AddApartment from "./add-apartment";
import uuidv4 from "../../tools/guidgenerator";
import * as Constants from "../../config";
import * as Vaules from "../../static data/selectvalues";
import { checkArrayDefined } from "../../tools/valueshelper";
import { useTranslation } from "react-i18next";

export default function Apartment() {

    const [apartmentModalOpened, setApartmentModalOpened] = useState(false);
    const { t } = useTranslation();
    const [selectedApart, setSelectedApart] = useState({});
    const [searchParams, setSearchParams] = useState({
        id: "",
        name: "",
        price: "",
        location: "",
        terrain: "",
        habitable: "",
        status: ""
    });
    const [checkboxDisabled, setCheckboxDisabled] = useState(false);
    const [searchApartments, setSarchApartments] = useState([]);
    const [apartments, setApartments] = useState([]);

    // === PAGINATION ===
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;
    const totalPages = Math.ceil(searchApartments.length / itemsPerPage);
    const paginatedApartments = searchApartments.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );

    const apart = {            
        id: uuidv4(),
        name: "",
        price: "",
        landarea: "",
        livingarea: "",
        propertytype: Vaules.propertyValues[0],
        typeofoffer: Vaules.offerValues[0],
        neighborhood: "",
        bedrooms: Vaules.chambersValues[0],
        showers: Vaules.bathValues[0],
        properties: [{ id: 0, name: "", options: [] }],
        images: []
    };

    function edit(a) {
        setSelectedApart(a);
        setApartmentModalOpened(true);
    }

    function add() {        
        apart.id = uuidv4();
        setSelectedApart(apart);
        setApartmentModalOpened(true);
    }

    const saveData = (data) => {
        var d = {};
        Object.assign(d, data);
        d.price = d.price.replaceAll(",", "").replaceAll(".", "");
        const body = Constants.requestBody(d);
        fetch(Constants.apiurl + Constants.apartments, body)
        .then(response => {
            if (response.status == 401) window.location.reload(false);
            return response.json();
        })
        .then(() => {
            getData();
        })
        .catch(err => {
            console.log(err.error);
        });
    };

    function editDone(a) {
        var newObj = [];
        Object.assign(newObj, apartments);
        const i = newObj.findIndex(x => x.id == a.id);
        if (i < 0) newObj.push(a);
        else newObj[i] = a;
        setApartments(newObj);
        saveData(a);
        closeModal();
    }

    function getData() {
        fetch(Constants.apiurl + Constants.apartments)
        .then((response) => response.json())
        .then((data) => {
            setApartments(data);
            setSarchApartments(data);
        })
        .catch((err) => {
           console.log(err.message);
        });
    }

    useEffect(() => {
        getData();
    }, []);

    useEffect(() => {
        search();
        setCurrentPage(1); // сбрасываем на первую страницу при поиске
    }, [searchParams]);

    function closeModal() {
        setApartmentModalOpened(false);
    }

    const delet = (x) => {
        fetch(Constants.apiurl + Constants.deleteapartments + "?id=" + x, Constants.requestHeaderOnly())
        .then(() => {
            getData();
        })
        .catch((err) => {            
            console.log(err.message);
        });
    };

    function checkboxClick(id) {
        var newObj = [];
        Object.assign(newObj, apartments);
        const i = newObj.findIndex(x => x.id == id);
        newObj[i].displayOnMain = !newObj[i].displayOnMain;
        setApartments(newObj);
        saveData(newObj[i]);
        if (newObj.filter(x => x.displayOnMain).length >= 6)
            setCheckboxDisabled(true);
        else
            setCheckboxDisabled(false);
    }

    function search() {
        var s = [];
        Object.assign(s, apartments);
        if (searchParams.id) s = s.filter(x => x.id?.includes(searchParams.id));
        if (searchParams.name) s = s.filter(x => x.name?.toLowerCase().includes(searchParams.name.toLowerCase()));
        if (searchParams.habitable) s = s.filter(x => x.livingarea?.toLowerCase().includes(searchParams.habitable.toLowerCase()));
        if (searchParams.location) s = s.filter(x => x.neighborhood?.toLowerCase().includes(searchParams.location.toLowerCase()));
        if (searchParams.price) s = s.filter(x => x.price?.toLowerCase().includes(searchParams.price.toLowerCase()));
        if (searchParams.terrain) s = s.filter(x => x.landarea?.toLowerCase().includes(searchParams.terrain.toLowerCase()));
        if (searchParams.status) s = s.filter(x => x.status?.toLowerCase().includes(searchParams.status.toLowerCase()));
        setSarchApartments(s);
    }

    return (
        <div>
            {apartmentModalOpened ? (
                <div className="modal-window">
                    <div>
                        <div className="close-icon" onClick={closeModal}>X</div>
                        <AddApartment closeWindow={closeModal} saveApart={editDone} apart={selectedApart}/>
                    </div>
                </div>
            ) : ""}

            <h2>{t('Offres')}</h2>
            <div onClick={add} className="add-button">{t('Ajouter')}</div>  

            <table className="apartment-table">
                <thead>
                    <tr>
                        <th>{t('Afficher sur la page')}</th>
                        <th>ID <input name="id" value={searchParams.id} onChange={(e)=>setSearchParams({...searchParams, id:e.target.value})}/></th>
                        <th>status <input name="status" value={searchParams.status} onChange={(e)=>setSearchParams({...searchParams, status:e.target.value})}/></th>
                        <th>{t('Nom')} <input name="name" value={searchParams.name} onChange={(e)=>setSearchParams({...searchParams, name:e.target.value})}/></th>
                        <th>{t('Prix')} <input name="price" value={searchParams.price} onChange={(e)=>setSearchParams({...searchParams, price:e.target.value})}/></th>
                        <th>{t('Location')} <input name="location" value={searchParams.location} onChange={(e)=>setSearchParams({...searchParams, location:e.target.value})}/></th>
                        <th>{t('Superficie terrain')} <input name="terrain" value={searchParams.terrain} onChange={(e)=>setSearchParams({...searchParams, terrain:e.target.value})}/></th>
                        <th>{t('Superficie habitable')} <input name="habitable" value={searchParams.habitable} onChange={(e)=>setSearchParams({...searchParams, habitable:e.target.value})}/></th>
                        <th style={{width:"220px"}}>{t('Actions')}</th>
                    </tr>
                </thead>
                <tbody>
                    {paginatedApartments.map((x) => (
                        <tr key={x.id}>
                            <td><input disabled={checkboxDisabled && !x.displayOnMain} type="checkbox" checked={x.displayOnMain} onChange={() => checkboxClick(x.id)} /></td>
                            <td>{x.id}</td>
                            <td>{x.status}</td>
                            <td>{x.name}</td>
                            <td>{x.price}</td>
                            <td>{x.neighborhood}</td>
                            <td>{x.landarea}</td>
                            <td>{x.livingarea}</td>
                            <td>
                                <div onClick={() => edit(x)} className="edit-button">{t('Editer')}</div>
                                <div onClick={() => delet(x.id)} className="delete-button">{t('Supprimer')}</div>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>

            {/* Pagination */}
            {totalPages > 1 && (
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", marginTop: "15px", gap: "10px" }}>
                    <button 
                        onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))} 
                        disabled={currentPage === 1}
                    >
                        ⬅️ {t('Précédent')}
                    </button>
                    <span>{t('Page')} {currentPage} / {totalPages}</span>
                    <button 
                        onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))} 
                        disabled={currentPage === totalPages}
                    >
                        {t('Suivant')} ➡️
                    </button>
                </div>
            )}
        </div>
    );
}
